const REQUEST_ID_PREFIX = 'freq_';
const REQUEST_ID_LENGTH = 19;
const REQUEST_ID_ALPHABET = 'abcdefghijklmnopqrstuvwxyz0123456789';

export const createRequestSessionId = () => {
  const randomValues =
    typeof window !== 'undefined' &&
    window.crypto &&
    typeof window.crypto.getRandomValues === 'function'
      ? window.crypto.getRandomValues(new Uint32Array(REQUEST_ID_LENGTH))
      : null;

  let suffix = '';
  for (let i = 0; i < REQUEST_ID_LENGTH; i += 1) {
    const value = randomValues?.[i] ?? Math.floor(Math.random() * 0xffffffff);
    suffix += REQUEST_ID_ALPHABET[value % REQUEST_ID_ALPHABET.length];
  }

  return `${REQUEST_ID_PREFIX}${suffix}`;
};

let requestSessionId = createRequestSessionId();

export const setRequestSessionId = (id) => {
  requestSessionId = id;
};

export const getRequestSessionId = () => requestSessionId;

export const ensureRequestSessionId = () => {
  if (!requestSessionId) {
    requestSessionId = createRequestSessionId();
  }

  return requestSessionId;
};

export const applyRequestSessionHeader = (headers = {}) => {
  if (!requestSessionId) return headers;

  return {
    ...headers,
    'x-request-id': requestSessionId,
  };
};
